import type { ReactNode } from "react";

import { cn } from "src/lib/utils";

interface SettingsPanelProps {
	title: string;
	description?: ReactNode;
	actions?: ReactNode;
	children: ReactNode;
	className?: string;
}

/** Card wrapper for a settings sub-panel, matching the prototype's Settings screen. */
const SettingsPanel = ({ title, description, actions, children, className }: SettingsPanelProps) => (
	<section className={cn("tw-rounded-lg tw-border tw-border-border tw-bg-white tw-shadow-card", className)}>
		<header className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-border tw-px-4 tw-py-3.5 sm:tw-px-5">
			<div className="tw-min-w-0">
				<h2 className="tw-text-[15px] tw-font-bold tw-text-text">{title}</h2>
				{description && <p className="tw-mt-0.5 tw-text-[13px] tw-text-text-soft">{description}</p>}
			</div>
			{actions && <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">{actions}</div>}
		</header>
		<div className="tw-p-4 sm:tw-p-5">{children}</div>
	</section>
);

export default SettingsPanel;
